export const NANOID_LEN = 12;
export const STARTING_PRICE_USD = '3000'; // USD
export const STARTING_BALANCE_ETH = '10'; // ETH
export const MAX_PREMIUM = 0.05; // 7%
